export var MuiRadioOverrides = {
  styleOverrides: {
    root: {
      '& .MuiSvgIcon-fontSizeSmall': {
        fontSize: '1rem'
      },
      '& .MuiSvgIcon-fontSizeMedium': {
        fontSize: '1.25rem'
      }
    }
  }
};